export default "__VITE_ASSET__Bigaa_bh__"